const React = require('react');
const ButtonDecline = require('../../../../dumb/Button/Decline');

module.exports = ({close}) => (
  <>
    <div className="mt30">
      While we were processing this refund, it status has been changed.
      We've updated page info, you can close this modal window now.
    </div>
    <div className="mt30">
      <ButtonDecline
        onClick={close}
      >Close</ButtonDecline>
    </div>
  </>
);
